import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addShiftFailure,
  addShiftSuccess,
  //
  deleteShiftSuccess,
  deleteShiftFailure,
  //
  editShiftSuccess,
  editShiftFailure,
  //
  fetchShiftFailure,
  fetchShiftSuccess,
  //
  getViewDataFailure,
  getViewDataSuccess,
  getHistorySuccess,
  getHistoryFailure,
  getClockHistorySuccess,
  getClockHistoryFailure,
} from "./actions";
import {
  ADD_SHIFT,
  EDIT_SHIFT,
  DELETE_SHIFT,
  FETCH_SHIFT,
  GET_VIEW_DATA,
  GET_HISTORY,
  GET_CLOCK_HISTORY,
} from "./constants";

export function* fetchShiftSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/shift?${query}`, payload);
    yield put(fetchShiftSuccess(data));
  } catch (e) {
    yield put(fetchShiftFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching shift!"));
  }
}

export function* getViewDataSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/shift/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addShiftSaga({ payload, onShiftAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).post, `/api/shift/add`, payload);
    if (data) {
      yield put(successAlert("Shift added successfully!"));
      yield put(addShiftSuccess());
      typeof onShiftAdd === "function" && onShiftAdd(data);
    }
  } catch (e) {
    yield put(addShiftFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editShiftSaga({ payload, onShiftEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/shift/edit/${payload.id}`,
      payload
    );
    if (data) {
      yield put(successAlert("Shift updated successfully!"));
      yield put(editShiftSuccess());
      typeof onShiftEdit === "function" && onShiftEdit(data);
    }
  } catch (e) {
    yield put(editShiftFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteShiftSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).delete, `/api/shift/${payload?.id}`);
    if (data) {
      yield put(successAlert("Shift deleted successfully!"));
      yield put(deleteShiftSuccess());
      typeof onDelete === "function" &&
        onDelete({
          ...payload,
          budget_details: data?.budget_details,
          shift_counts: data?.shift_counts,
          shift_data: data?.shift_data,
        });
    }
  } catch (e) {
    yield put(deleteShiftFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getHistorySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/shift-history/${payload.shift_id}`
    );
    if (data) {
      yield put(getHistorySuccess(data));
    }
  } catch (e) {
    yield put(getHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getClockHistorySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/clock-in-out-history/${payload.clock_id}`
    );
    if (data) {
      yield put(getClockHistorySuccess(data));
    }
  } catch (e) {
    yield put(getClockHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchShiftFlow() {
  yield takeEvery(FETCH_SHIFT, fetchShiftSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addShiftFlow() {
  yield takeEvery(ADD_SHIFT, addShiftSaga);
}
export function* editShiftFlow() {
  yield takeEvery(EDIT_SHIFT, editShiftSaga);
}
export function* deleteShiftFlow() {
  yield takeEvery(DELETE_SHIFT, deleteShiftSaga);
}
export function* getHistoryFlow() {
  yield takeEvery(GET_HISTORY, getHistorySaga);
}
export function* getClockHistoryFlow() {
  yield takeEvery(GET_CLOCK_HISTORY, getClockHistorySaga);
}

export default function* ShiftSaga() {
  yield all([
    fetchShiftFlow(),
    addShiftFlow(),
    editShiftFlow(),
    deleteShiftFlow(),
    getViewDataFlow(),
    getHistoryFlow(),
    getClockHistoryFlow(),
  ]);
}
